import RestartAltIcon from '@mui/icons-material/RestartAlt'
import { Button } from '@mui/material'
import { Box } from '@mui/system'
import { resetEventFilters } from 'context'
import { spacingOne } from 'utility/spacings'
import { OrderByFilter } from '.'
import { OrderFilter } from './Filters/OrderFilter'
import { QueryFilter } from './Filters/QueryFilter'
import { TypeFilter } from './Filters/TypeFilter/TypeFilter'

export const EventFilters = () => {
  return (
    <Box sx={{ padding: spacingOne, width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'right', paddingBottom: spacingOne }}>
        <Button onClick={resetEventFilters} size="small">
          <RestartAltIcon color="action" />
        </Button>
      </Box>
      <Box sx={{ display: 'flex', paddingBottom: spacingOne }}>
        <TypeFilter />
        <OrderFilter />
        <OrderByFilter />
      </Box>
      <Box>
        <QueryFilter />
      </Box>
    </Box>
  )
}
